import { Spinner as ThemeUISpinner } from 'theme-ui';

const Spinner = (props) => <ThemeUISpinner {...props}>{props.children}</ThemeUISpinner>;

export default Spinner;
